class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


(function () {
  'use strict';

  function updateShippingBar() {
    var bar     = document.getElementById('CartDrawer-ShippingBar');
    var content = document.getElementById('ShippingBar-Content');
    var track   = document.getElementById('ShippingBar-Track');
    var fill    = document.getElementById('ShippingBar-Fill');
    if (!bar || !content) return;

    var country   = (document.body.dataset.customerCountry || '').toLowerCase();
    var cartTotal = parseInt(bar.dataset.cartTotal || '0', 10);
    var threshold = parseInt(bar.dataset.threshold || '0', 10);

    // ── France: always free, no progress bar ─────────────────────────
    if (country === 'fr') {
      content.innerHTML =
        '<div class="shipping-bar__success">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M19.8 4.2C17.7 2.1 14.9 1 12 1S6.3 2.1 4.2 4.2 1 9.1 1 12s1.1 5.7 3.2 7.8S9.1 23 12 23s5.7-1.1 7.8-3.2S23 14.9 23 12s-1.1-5.7-3.2-7.8zm-1.4 14.2c-1.7 1.7-4 2.6-6.4 2.6s-4.7-.9-6.4-2.6C3.9 16.7 3 14.4 3 12s.9-4.7 2.6-6.4S9.6 3 12 3s4.7.9 6.4 2.6S21 9.6 21 12s-.9 4.7-2.6 6.4zM16.3 8.3 11 13.6l-2.3-2.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.2.2.5.3.7.3s.5-.1.7-.3l6-6c.4-.4.4-1 0-1.4s-1-.4-1.4 0z" fill="#2d6a4f"/></svg>' +
          '<span>\uD83C\uDDEB\uD83C\uDDF7 <strong>Livraison gratuite</strong> vers la France</span>' +
        '</div>';
      if (track) track.hidden = true;
      bar.style.opacity = '1';
      return;
    }

    // ── No threshold set → hide silently ─────────────────────────────
    if (threshold <= 0) {
      bar.style.display = 'none';
      return;
    }

    var remaining = threshold - cartTotal;
    var pct       = Math.min(100, Math.round((cartTotal / threshold) * 100));

    if (remaining <= 0) {
      // ── Threshold reached ─────────────────────────────────────────
      content.innerHTML =
        '<div class="shipping-bar__success">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path d="M19.8 4.2C17.7 2.1 14.9 1 12 1S6.3 2.1 4.2 4.2 1 9.1 1 12s1.1 5.7 3.2 7.8S9.1 23 12 23s5.7-1.1 7.8-3.2S23 14.9 23 12s-1.1-5.7-3.2-7.8zm-1.4 14.2c-1.7 1.7-4 2.6-6.4 2.6s-4.7-.9-6.4-2.6C3.9 16.7 3 14.4 3 12s.9-4.7 2.6-6.4S9.6 3 12 3s4.7.9 6.4 2.6S21 9.6 21 12s-.9 4.7-2.6 6.4zM16.3 8.3 11 13.6l-2.3-2.3c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3 3c.2.2.5.3.7.3s.5-.1.7-.3l6-6c.4-.4.4-1 0-1.4s-1-.4-1.4 0z" fill="#2d6a4f"/></svg>' +
          '<span> <strong>Livraison gratuite</strong> d\u00e9bloqu\u00e9e\u00a0!</span>' +
        '</div>';
      if (fill)  fill.style.width = '100%';
      if (track) track.hidden = false;
    } else {
      // ── Progress toward threshold ─────────────────────────────────
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      var formatted;
      try {
        formatted = new Intl.NumberFormat(navigator.language, {
          style: 'currency', currency: currency,
          minimumFractionDigits: 0, maximumFractionDigits: 2
        }).format(remaining / 100);
      } catch (e) {
        formatted = (remaining / 100).toFixed(2) + '\u00a0' + currency;
      }
      content.innerHTML =
        '<p class="shipping-bar__text">' +
          'Plus que <span class="highlight">' + formatted + '</span>' +
          ' pour la <strong>livraison gratuite</strong>' +
        '</p>';
      if (fill)  fill.style.width = pct + '%';
      if (track) track.hidden = false;
    }

    bar.style.opacity = '1';
  }

  // ── Initial run — wait for async geo attribution on <body> ───────────
  var attempts = 0;
  var poll = setInterval(function () {
    if (document.body.dataset.customerCountry || ++attempts >= 20) {
      clearInterval(poll);
      updateShippingBar();
    }
  }, 150);

  // ── Observe both Dawn render paths ───────────────────────────────────
  //
  // Path A: add-to-cart from PDP
  //   CartDrawer.renderContents → sets #CartDrawer.innerHTML
  //   → childList fires on #CartDrawer
  //
  // Path B: qty change / remove inside the drawer
  //   CartDrawerItems → sets .drawer__inner.innerHTML
  //   → childList fires on .drawer__inner only, NOT on #CartDrawer
  //
  // Solution: observe #CartDrawer for path A and re-attach the
  // .drawer__inner observer when .drawer__inner itself is recreated,
  // plus observe .drawer__inner directly for path B.

  function attachInnerObserver() {
    var inner = document.querySelector('#CartDrawer .drawer__inner');
    if (!inner) return;
    new MutationObserver(function (mutations) {
      var changed = mutations.some(function (m) {
        return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
      });
      if (changed) updateShippingBar();
    }).observe(inner, { childList: true });
  }

  var cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    new MutationObserver(function (mutations) {
      var changed = mutations.some(function (m) {
        return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
      });
      if (changed) {
        updateShippingBar();
        attachInnerObserver(); // .drawer__inner was recreated — re-attach
      }
    }).observe(cartDrawerEl, { childList: true });
  }

  // Attach immediately for path B (drawer already in DOM on page load)
  attachInnerObserver();

})();